import React, { Component } from 'react';
import { Link } from 'react-router';

class TrainingPage extends Component {
    render(){

        const { network } = this.props.params;

        return (
            <div className="not-found">
                <h1 className="h1">Training Page</h1>
                <Link to={ `/training/courses` }>Courses</Link>
                <Link to={ `/training/interactive-webinars` }>Webinars</Link>
                <Link to={ `/training/podcasts` }>Podcasts</Link>
            </div>
        );
    }
};

export default TrainingPage;



// WEBPACK FOOTER //
// src/client/components/site/pages/TrainingPage.js